import * as React from 'react';
import classnames from 'classnames';
import { SelectionBoxRadio } from '@grandvisionhq/common';
import '@grandvisionhq/forms';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/state';
import '@grandvisionhq/analytics';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import '../../../../../types/product.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import '@swc/helpers';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/inventory';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/lib-utils-html';
import '../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import { TileLayout } from '../../../components/TileLayout/TileLayout.js';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../hooks/useCartDiscounts/types.js';
import '../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../hooks/use-product-view-history.js';
import '../../../../../slots/context.js';
import '@grandvisionhq/content';

const SunglassesRxableSelect = ({ className , items , selectedValue , onChange ,  })=>{
    return /*#__PURE__*/ React.createElement("fieldset", {
        className: classnames('sunglasses-rxable-select', className)
    }, items.map(({ value , label , iconName  })=>{
        return /*#__PURE__*/ React.createElement(SelectionBoxRadio, {
            key: value,
            name: "sunglasses-rxable-select",
            value: value,
            checked: selectedValue === value,
            onChange: ()=>onChange(value)
            ,
            "data-t": value
        }, /*#__PURE__*/ React.createElement(TileLayout, {
            title: label,
            iconName: iconName
        }));
    }));
};

export { SunglassesRxableSelect };
//# sourceMappingURL=SunglassesRxableSelect.js.map
